import React from "react";
import { useParams } from "react-router-dom";
import Orders from "./Orders";
import Billing from "./Billing";
import Credit from "./Credit";
import Crateledger from "./Crateledger";
import Pogenerate from "./Pogenerate"; 
import Stats from "./Stats";
import Cashfloat from "./Cash-float";
import Fyreport from "./Fy-report";
import Addon from "./Addon.js";
import NotFound from "./NotFound";
import CashAnalytics from "./CashAnalytics";
import BillInfo from "./BillInfo";

const formComponents = {
  1: Orders,
  2: Credit,
  3: Billing,
  4: Crateledger,
  5: Pogenerate,
  6: Cashfloat,
  7: Fyreport,
  8: Addon,
  9: Stats,
  10: CashAnalytics,
  11: BillInfo,
};

const FormLoader = () => {
  const { form_id } = useParams(); // Get form ID from URL

  const FormComponent = formComponents[form_id];
  return FormComponent ? <FormComponent /> : <NotFound />;
};

export default FormLoader;
